import React,{useState, useEffect} from 'react';
import api from '../../services/api';
import Toastify from '../../components/Toastify';
import {getallusers} from '../../services/servicesGetAllUsers';
import {GetUsersByNameOrEmail} from '../../services/servicesGetUsersByNameOrEmail';
import {UpdateUser} from '../../services/servicesUpdateUser';
import {TrCliente,TrHeadCliente,DivClientes,InputBusca, Button, SpanButton,DivBusca} from './styledClientes';
import Popup from 'reactjs-popup'
export default function Clientes(){

const[clientes, setClientes] = useState([]);
const[busca, setBusca] = useState();
const[popup, setPopup] = useState(false);
const[dados, setDados] = useState([]);
const[buscaResultado, setBuscaResultado] = useState([])
const[dadosEdicao, setDadosEdicao] = useState({
    MyId :'',
    Name :'',
    Email :'',
    SubscribeDate :'',
    ValidDate :'',
    Admin :'',
    PlanPrice :'',
    PlanCurrentPrice :''});


    async function getAllUsers(){
        const data = await getallusers();
        setClientes(data);
        setDados(data);
    }
    async function getUsersByNameOrEmail(texto){
        try{
            const {data} = await GetUsersByNameOrEmail(texto);
            if(data.Message){
                Toastify.error('Não foi possível buscar')
                return;
            }
            setDados(data);
        }catch(error){
            Toastify.error('Não foi possível realizar a busca')
        }

    }
    function abreBusca(event){

        if(event.key === 'Enter'){
            if(busca == ''){
                setDados(clientes)
            }else{

                getUsersByNameOrEmail(event.target.value);
            }
            // setBuscaOpen(true);
        }
    };

    async function updateUser(event,obj_user){
        try{
            event.preventDefault();
            let data = await UpdateUser(obj_user);
            if (data === 'Success'){
                Toastify.success('Perfil editado com sucesso');
                setPopup(false);
            }
        }catch(error){
            Toastify.error('Não foi possível editar o usuário.');
            console.log(error);
        }
    }

    function SelecionaCliente(item_obj){
        setDadosEdicao(
            {
                MyId : item_obj.MyId,
                Name : item_obj.Name,
                Email : item_obj.Email,
                SubscribeDate : item_obj.SubscribeDate,
                ValidDate : item_obj.ValidDate,
                Admin : item_obj.Admin,
                PlanPrice : item_obj.PlanPrice,
                PlanCurrentPrice :item_obj.PlanCurrentPrice
            }
        );
        setPopup(true);
    }

    async function SalvaEdicaoCliente(event, dadosCliente){
        event.preventDefault();
        let resposta = await UpdateUser(dadosCliente);
    }

    function ArrumaData(date){
        let data = date.split('T');
        return data[0];
    }

    useEffect(()=>{
        getAllUsers();
        console.log('clientes', dados);
        // console.log(window.screen.width)
    },[])


    return(
        <DivClientes>
            <DivBusca style={{display:'flex',justifyContent:'space-between'}}>
                <InputBusca
                type='text'
                 placeholder='Informe o nome ou o email do cliente'
                 value={busca || ''}
                 onChange={(event)=>{setBusca(event.target.value)}}
                 onKeyPress={(event)=>{abreBusca(event)}} />
                 {window.screen.width < 800 ?
                    <Button onClick={()=>{getUsersByNameOrEmail(busca)}}>
                        <SpanButton>Busca</SpanButton>
                    </Button> :''}
            </DivBusca>
            <table style={{width:'100%', borderCollapse:'collapse'}}>
                <thead style={{marginBottom:'10px'}}>
                    {window.screen.width > 800?
                    <TrHeadCliente>
                        <th>#</th>
                        <th>Id</th>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Data de inscrição</th>
                        <th>Data de Validade</th>
                        <th>Facebook_id</th>
                        <th>Admin</th>
                    </TrHeadCliente>
                    :
                    <TrHeadCliente>
                        <th>#</th>
                        <th>Nome</th>
                        <th>Email</th>
                    </TrHeadCliente>
                    }
                </thead>
                <tbody>
                    {window.screen.width > 800 ?
                        dados.map((item,index)=>{
                            return(
                                <TrCliente key={index} background={index%2 == 0?'#fff':'' } onDoubleClick={()=>{SelecionaCliente(item)}}>
                                    <td onClick={()=>{SelecionaCliente(item)}} style={{cursor:'pointer'}}>Edit</td>
                                    <td>{item.MyId}</td>
                                    <td>{item.Name}</td>
                                    <td>{item.Email}</td>
                                    <td>{ArrumaData(item.SubscribeDate).split('-')[2] }/{ArrumaData(item.SubscribeDate).split('-')[1] }/{ArrumaData(item.SubscribeDate).split('-')[0] }</td>
                                    <td>{ArrumaData(item.ValidDate).split('-')[2] }/{ArrumaData(item.ValidDate).split('-')[1] }/{ArrumaData(item.ValidDate).split('-')[0] }</td>
                                    <td>{item.Facebook_id}</td>
                                    <td>{item.Admin == 0  ? <input type='checkbox'/>: <input type='checkbox' checked/>} </td>
                                </TrCliente>
                            )
                        })
                    :
                        dados.map((item,index)=>{
                            return(
                                <TrCliente key={index} style={{textAlign:'center'}}>
                                    <td onClick={()=>{SelecionaCliente(item)}} style={{cursor:'pointer'}}>Edit</td>
                                    <td>{item.Name}</td>
                                    <td>{item.Email}</td>
                                </TrCliente>
                            )
                        })
                    }
                </tbody>
            </table>
            <Popup open={popup}
            closeOnDocumentClick={false}
            onClose={()=>setPopup(false)}
            contentStyle={{width:window.screen.width > 800 ?'50%' :'unset'}}    >
                <div style={{display:'flex', flexDirection:'column',cursor:'default'}}>
                    <span><strong>Nome</strong></span>
                    <input style={{margin:'10px 0', height:"30px"}} type='text' value={dadosEdicao.Name}
                        onChange={(event)=>{setDadosEdicao({...dadosEdicao,Name:event.target.value})}} />
                    <span><strong>Email</strong></span>
                    <input style={{margin:'10px 0', height:"30px"}} type='text' value={dadosEdicao.Email}
                        onChange={(event)=>{setDadosEdicao({...dadosEdicao,Email:event.target.value})}} />
                    <span><strong>Data de Inscrição</strong></span>
                    <input style={{margin:'10px 0', height:"30px"}} type='date' value={ArrumaData(dadosEdicao.SubscribeDate)}
                        onChange={(event)=>{setDadosEdicao({...dadosEdicao,SubscribeDate:event.target.value+'T00:00:00'})}} />
                    <span><strong>Data de Validade</strong></span>
                    <input style={{margin:'10px 0', height:"30px"}} type='date'
                        value={ArrumaData(dadosEdicao.ValidDate)}
                        onChange={(event)=>{setDadosEdicao({...dadosEdicao,ValidDate:event.target.value+'T00:00:00'})}} />
                    <div style={{display:'flex',alignItems: 'center'}}>
                        <span style={{marginRight:'10px'}} ><strong>Admin</strong></span>
                        <input style={{margin:'10px 0', height:"30px"}} type='checkbox'
                            checked={dadosEdicao.Admin}
                            value={dadosEdicao.Admin}
                            onChange={(event)=>{setDadosEdicao({...dadosEdicao,Admin:!dadosEdicao.Admin})}}
                        />
                    </div>
                    <span><strong>Current Price</strong></span>
                    <input style={{margin:'10px 0', height:"30px"}} type='text' value={dadosEdicao.PlanCurrentPrice}
                        onChange={(event)=>{setDadosEdicao({...dadosEdicao,PlanCurrentPrice:event.target.value})}} />
                    <span><strong>Plan Price</strong></span>
                    <input style={{margin:'10px 0', height:"30px"}} type='text' value={dadosEdicao.PlanPrice}
                        onChange={(event)=>{setDadosEdicao({...dadosEdicao,PlanPrice:event.target.value})}} />

                    <div     style={{display: 'flex',width:window.screen.width > 800 ?'100%' :'300px',justifyContent: 'space-between'}}>
                        <Button style={{width:window.screen.width > 800 ?'' :'120px'}}
                            onClick={(event)=>{updateUser(event, dadosEdicao) }}>
                            <SpanButton style={{fontSize:'14px'}}>Salvar</SpanButton>
                        </Button>
                        <Button style={{width:window.screen.width > 800 ?'' :'120px'}}
                            onClick={()=>{setPopup(false) }}>
                            <SpanButton style={{fontSize:'14px'}}>Cancelar</SpanButton>
                        </Button>
                    </div>
                </div>
            </Popup>
        </DivClientes>
    )

}
